export default __webpack_public_path__ + "static/media/bg-cover1.508fb721.png";